import React, { useState, useEffect } from 'react';
// import '../styles.css';

import { toast } from 'react-toastify';

import { Button, Col, Row, Table } from 'react-bootstrap';
import { userStore } from 'store/UserStore';
import { makeQuery } from 'utils';
import Alert from 'shared/common/alert';
import giftHttp from './services/gift.service';
import { Pagination } from 'shared/common/pagination';

interface PropsType {}

const SentGifts: React.FC<PropsType> = ({}) => {
  const [loading, setLoading] = useState<any>(false);
  const [giftsList, setGiftsList] = useState<any>([]);
  const [customerId, setUser, user, customer] = userStore((state: any) => [
    state.customerId,
    state.setUser,
    state.user,
    state.customer,
  ]);
  const [metaData, setMetaData] = useState<any>({});
  const [currentPage, setCurrentPage] = useState<number>(0);

  // const sentGiftsList = async () => {
  //   try {
  //     const res = await giftHttp.sendGiftsList(customerId);
  //     console.log('receivedGiftsList', res);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const sentGiftsList = async (page) => {
    try {
      const res = await giftHttp.sentGiftsList(
        customerId,
        customer?.partner?.id,
        page
      );
      if (res?.status == 200) {
        setGiftsList(res?.data?.data?.result);
        setCurrentPage(page);
        setMetaData({
          current: res.data.meta.page,
          pages: res.data.meta.totalPages + 1,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    sentGiftsList(0);
  }, []);

  return (
    <>
      <div className='t-wrap overflow-auto'>
        <Table className='mb-0 w-100 txn__table' striped hover responsive>
          <thead>
            <tr>
              {/* <th>Id</th> */}
              <th>To</th>
              <th>Mobile</th>
              <th>Metal</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {giftsList[0] ? (
              giftsList?.map((gift, index) => (
                <tr key={index}>
                  {/* <td>{gift?.id}</td> */}
                  <td>{gift?.receiverName}</td>
                  <td>{gift?.receiverMobileno}</td>
                  <td>{gift?.metal}</td>
                  <td>
                    <div
                      className={`badge ${
                        gift?.status == 'ACCEPTED' || gift?.status == 'ACTIVE'
                          ? 'bg-success'
                          : 'bg-secondary'
                      }`}
                    >
                      {gift?.status}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4}>
                  <div className='m-2 d-flex justify-content-center'>
                    No data to display
                  </div>
                </td>
              </tr>
            )}

            {/* )} */}
          </tbody>
        </Table>
      </div>
      <Row>
        <Col md={12}>
          {/* Pagination Bar */}
          {!loading && metaData.pages > 1 && (
            <Pagination
              meta={metaData}
              handlePageChange={(number: number) => sentGiftsList(number)}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default SentGifts;
